//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isProductType } from '@motionelements/core/src/services/catalog.service.js';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
// Hover preview is not a user gesture: play() must start muted. Unmute only after page interaction (or mute pref).
// See installMediaUserGesture on search.
import {
  applyInlinePlayback,
  bindVideoOrientationObjectFit,
  hasMediaUserGesture,
  resolveHoverPreviewMuted,
} from '@motionelements/helper/player/nativeVideo';

export default {
  name: 'product-card-preview-default',
  mixins: [featureFlagMixin],
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  data() {
    return {
      flowplayer: null,
      isFirstPlay: true,
      isPlaying: false,
      nativeVideoElVisible: false,
      nativeVideoPlaying: false,
    };
  },
  props: {
    element: Object,
    isHovering: {
      type: Boolean,
      default: false,
    },
    // mute: {
    //   type: Boolean,
    //   default: true,
    // },
  },
  computed: {
    posterImageUrl() {
      return _.get(this.element, 'thumbnail.url')
        || _.get(this.element, 'thumbnails.jpg.url')
        || 'https://static.moele.me/img/placeholders/placeholder-640x360-light.jpg?w=480';
    },
    videoUrl() {
      // Search grid hover: thumbnails.mp4 ?? previews.mp4 (detail modal uses nativeVideo pickVideoSrc)
      const videoUrl = _.get(this.element, 'thumbnails.mp4.url') || _.get(this.element, 'previews.mp4.url');

      // just in case, check if is mp4
      if (!videoUrl || videoUrl.lastIndexOf('.mp4') === -1) {
        return null;
      }

      return videoUrl;
    },
    showStaticPreview() {
      return !(isProductType('image', this.mediaType) || isProductType('3d_model', this.mediaType));
    },
    isSearchResultPage() {
      const isSearchRepo = process.env.VUE_APP_PROJECT_NAME && process.env.VUE_APP_PROJECT_NAME === 'frontend-search';
      return isSearchRepo && this.$route.name.indexOf('view-search') > -1;
    },
    muteSetting() {
      // default mute when not in result page
      if (!this.isSearchResultPage) {
        return true;
      }
      const browserIsMobile = this.$store.state.browser && this.$store.state.browser.isMobile;
      if (browserIsMobile) {
        return true;
      }
      return this.$store.getters['search/videoPlayerMuted'];
    },
    allowAudibleHoverPreview() {
      if (!this.isSearchResultPage || this.muteSetting) {
        return false;
      }
      const browserIsMobile = this.$store.state.browser && this.$store.state.browser.isMobile;
      if (browserIsMobile) {
        return false;
      }
      return true;
    },
    hoverPreviewMediaUserGesture() {
      if (!this.isSearchResultPage) {
        return hasMediaUserGesture();
      }
      return this.$store.getters['search/hoverPreviewMediaUserGesture'];
    },
    effectiveMuted() {
      return resolveHoverPreviewMuted({
        isPlaying: this.nativeVideoPlaying,
        userWantsMuted: this.muteSetting,
        allowAudibleHover: this.allowAudibleHoverPreview,
        hasUserGesture: this.hoverPreviewMediaUserGesture,
      });
    },
    useNativeVideoPreview() {
      return this.isFeatureEnabled('product_preview_native_video');
    },
  },
  watch: {
    muteSetting() {
      this.applyVideoMuteState();
    },
    hoverPreviewMediaUserGesture() {
      this.applyVideoMuteState();
    },
    isHovering(state) {
      if (state) {
        if (this.useNativeVideoPreview && this.videoUrl) {
          this.nativeVideoElVisible = true;
        }
        setTimeout(() => {
          this.doPlay();
        },
        150); // delay
      } else {
        this.doPause();
        if (this.useNativeVideoPreview) {
          this.nativeVideoElVisible = false;
        }
      }
    },
  },
  beforeDestroy() {
    if (this.useNativeVideoPreview) {
      this.teardownNativeVideo();
    } else if (this.flowplayer !== null) {
      this.flowplayer.mute(false); // need reset the setting before destory, prevent change page still mute
      this.flowplayer.shutdown();
      this.flowplayer = null;
    }
  },
  methods: {
    applyVideoMuteState() {
      const video = this.$refs.previewVideo;
      if (!video || !this.nativeVideoPlaying) {
        return;
      }
      video.muted = this.effectiveMuted;
    },
    doPlay() {
      if (!this.isHovering) return false;

      if (this.useNativeVideoPreview) {
        return this.doPlayNative();
      }

      // console.log('onPlay', [this.element.id]);

      if (!this.flowplayer) {
        this.initVideoPlayer(this.element);
        // check again after init
        if (!this.isHovering) return false;
      }

      this.flowplayer.load();
      this.flowplayer.play();
      this.flowplayer.mute(this.muteSetting);

      this.isPlaying = true;
      this.$bus.$emit('product-video-player-load-play', this.element);

      if (this.isFirstPlay) {
        // emit after playing for 1s, to prevent accidental tracking
        setTimeout(() => {
          // check if it's still playing
          if (this.isPlaying) {
            this.$emit('previewed', true);
            this.isFirstPlay = false;
          }
        }, 1000);
      }

      return true;
    },
    doPause() {
      if (this.useNativeVideoPreview) {
        return this.doPauseNative();
      }

      if (!this.flowplayer) return true;

      this.flowplayer.pause();
      this.flowplayer.unload();

      this.isPlaying = false;
      this.$bus.$emit('product-video-player-pause-unload', this.element);

      return true;
    },
    doPlayNative() {
      if (!this.isHovering || !this.videoUrl) {
        return false;
      }

      this.$nextTick(() => {
        const video = this.$refs.previewVideo;
        if (!video || !this.isHovering) {
          return false;
        }

        applyInlinePlayback(video);
        bindVideoOrientationObjectFit(video, { horizontal: 'cover' });

        const currentSrc = video.getAttribute('src') || '';
        if (currentSrc !== this.videoUrl) {
          video.src = this.videoUrl;
          video.load();
        }

        this.removeNativeVideoLoadListener(video);

        const startPlayback = () => {
          if (!this.isHovering) {
            return;
          }
          // Hover is not a user gesture — always start muted so play() is allowed on a fresh page.
          video.muted = true;
          const playPromise = video.play();
          if (!playPromise || typeof playPromise.then !== 'function') {
            this.nativeVideoPlaying = true;
            this.applyVideoMuteState();
            return;
          }
          playPromise
            .then(() => {
              if (!this.isHovering) {
                return;
              }
              this.nativeVideoPlaying = true;
              this.applyVideoMuteState();
            })
            .catch(() => {
              this.nativeVideoPlaying = false;
            });
        };

        if (video.readyState >= 2) {
          startPlayback();
        } else {
          const onLoadedData = () => {
            this.removeNativeVideoLoadListener(video);
            startPlayback();
          };
          this.nativeVideoLoadedDataHandler = onLoadedData;
          video.addEventListener('loadeddata', onLoadedData);
        }

        this.isPlaying = true;
        this.$bus.$emit('product-video-player-load-play', this.element);

        if (this.isFirstPlay) {
          setTimeout(() => {
            if (this.isPlaying) {
              this.$emit('previewed', true);
              this.isFirstPlay = false;
            }
          }, 1000);
        }

        return true;
      });

      return true;
    },
    doPauseNative() {
      this.clearNativeVideoSource();
      this.isPlaying = false;
      this.nativeVideoPlaying = false;
      this.$bus.$emit('product-video-player-pause-unload', this.element);

      return true;
    },
    removeNativeVideoLoadListener(video) {
      const el = video || this.$refs.previewVideo;
      if (!el || !this.nativeVideoLoadedDataHandler) {
        return;
      }
      el.removeEventListener('loadeddata', this.nativeVideoLoadedDataHandler);
      this.nativeVideoLoadedDataHandler = null;
    },
    clearNativeVideoSource() {
      const video = this.$refs.previewVideo;
      if (!video) {
        return;
      }
      this.removeNativeVideoLoadListener(video);
      video.pause();
      video.removeAttribute('src');
      video.load();
    },
    teardownNativeVideo() {
      this.clearNativeVideoSource();
      this.isPlaying = false;
      this.nativeVideoPlaying = false;
      this.nativeVideoElVisible = false;
    },
    previewImgError(event) {
      event.target.src = 'https://static.moele.me/img/me-thumb-placeholder.180718.png';
    },
    initVideoPlayer(element) {
      // if (!_.get(this.options, 'enablePlayer')) {
      //   return;
      // }

      const videoUrl = this.videoUrl;

      // just in case, check if is mp4
      if (!videoUrl) {
        return;
      }

      const container = document.getElementById(`player-${element.id}`);
      // const $card = $(this.$el);

      this.flowplayer = flowplayer(container, {
        engine: 'html5',
        // key: (['production', 'stage'].indexOf(process.env.NODE_ENV) >= 0) ? process.env.VUE_APP_FLOWPLAYER_KEY : '',
        key: process.env.VUE_APP_FLOWPLAYER_KEY,
        // debug: (['production', 'stage'].indexOf(process.env.NODE_ENV) >= 0) ? false : true,
        // debug: !isProduction,
        debug: false,
        aspectRatio: '16:9',
        preload: 'auto',
        autoplay: true,
        splash: true,
        loop: true,
        muted: this.muteSetting,
        clip: {
          sources: [
            {
              type: 'video/mp4',
              src: videoUrl,
            },
          ],
        },
      });

      // // Add class to adjust the badge-actionable area for Timeline clearance
      // api
      //   .on('resume', () => {
      //     $card.addClass('is-playing has-played');
      //     this.$emit('update:cardPlayStatus', 'playing');

      //     this.$bus.$emit('audio-player-stop');
      //   })
      //   .on('unload', () => {
      //     $card.removeClass('is-playing');
      //     this.$emit('update:cardPlayStatus', 'paused');
      //   });
    },
  },
};
